export const LIFECHAIN_RPC = 'https://rpc-testnet.lif3.com'
export const LIFECHAIN_REST = 'https://mainnet-rest.lif3.com'
export const LIFE_TESTNET_CHAIN_REST = 'https://testnet-rest.lif3.com'
export const getPublicKeyLsKey = (account: string) => `lifechain_${account}_pubkey`
export const VALIDATORS_STAKING_CONTRACT_ADDRESS = '0x0000000000000000000000000000000000000800'
export const VALIDATORS_DISTRIBUTION_CONTRACT_ADDRESS = '0x0000000000000000000000000000000000000801'
